import { VXETable } from 'vxe-table'
// import SignObject from '../../public/utils/signJpg'
import XEUtils from 'xe-utils'
import { ykDateFormat, AmountLtoU } from '../../public/utils/globalFunc'
import http from '../../axios/index'
import { convertSign } from '../../public/utils/getSign'
import { Message } from 'element-ui'

// 打印
export const handlePrint = async row => {
  const { data: res } = await http.get('/finance/users')
  if (!res.isSuccess) {
    Message.error(res.errorMessage)
    return false
  }

  const SignObject = convertSign(res.data)

  let DetailHtmlList = []
  let traffic_sum_count = 0
  let traffic_sum_amount = 0

  let stay_sum_count = 0
  let stay_sum_amount = 0

  let meal_sum_amount = 0
  let miscellaneous_sum_amount = 0

  for (const item of row.detailList) {
    traffic_sum_count = XEUtils.sum([traffic_sum_count, item.traffic_invoice_count])
    traffic_sum_amount = XEUtils.sum([traffic_sum_amount, item.traffic_invoice_amount])
    stay_sum_count = XEUtils.sum([stay_sum_count, item.stay_invoice_count])
    stay_sum_amount = XEUtils.sum([stay_sum_amount, item.stay_invoice_amount])

    meal_sum_amount = XEUtils.sum([meal_sum_amount, item.meal_Total])
    miscellaneous_sum_amount = XEUtils.sum([miscellaneous_sum_amount, item.miscellaneous_Total])

    let meal_str = ''
    let miscellaneous_str = ''

    if (item.meal_Total) {
      meal_str = `${item.meal_allowance}*${item.travel_days}=${item.meal_Total}`
    }

    if (item.miscellaneous_Total) {
      miscellaneous_str = `${item.miscellaneous_expenses}*${item.travel_days}=${item.miscellaneous_Total}`
    }

    let total_amount = 0

    for (const key of ['meal_Total', 'miscellaneous_Total', 'traffic_invoice_amount', 'stay_invoice_amount']) {
      total_amount = XEUtils.sum([total_amount, item[key]])
    }

    DetailHtmlList.push(`
            <tr>
              <td>${ykDateFormat('MM-dd', item.begin_date)}</td>
              <td>${item.begin_address} ${item.end_address ? '- ' + item.end_address : ''}</td>
              <td>${item.traffic_type}</td>
              <td>${item.traffic_invoice_count}</td>
              <td>${item.traffic_invoice_amount}</td>
              <td>${item.stay_invoice_count}</td>
              <td>${item.stay_invoice_amount}</td>
              <td>${meal_str}</td>
              <td>${miscellaneous_str}</td>
              <td>${total_amount}</td>
              <td>${item.memo}</td>
            </tr>
        `)
  }

  const detailLineCount = 10
  if (DetailHtmlList.length < detailLineCount) {
    for (let i = detailLineCount - DetailHtmlList.length; i > 0; i--) {
      DetailHtmlList.push(`
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
          `)
    }
  }
  let caiwuSign = ''
  let lingongSign = ''
  let yaozongSign = ''

  if (row.manager_review && row.document_status > 1) {
    lingongSign = `<img src="${SignObject['林源晟']}" />`
  }

  if (row.document_status > 2) {
    caiwuSign = `<img src="${SignObject['连燕燕']}" />`
  }

  if (row.document_status > 5) {
    yaozongSign = `<img src="${SignObject['姚杨']}" />`
  }

  let personSign = ''
  if (row.users_names) {
    personSign = '<div class="signsContainer">出差人:<div class="signItems">'
    const users_names_list = row.users_names.split(',')
    if (users_names_list.length > 3) {
      for (const users_name of users_names_list) {
        if (SignObject[users_name]) {
          personSign = personSign + `<img src="${SignObject[users_name]}" />`
        } else {
          personSign = personSign + `<span>${users_name}</span>`
        }
      }
    } else if (users_names_list.length <= 3) {
      const users_names_list = row.users_names.split(',')

      for (const users_name of users_names_list) {
        if (SignObject[users_name]) {
          personSign = personSign + `<img style="width: 70px !important;" src="${SignObject[users_name]}" />`
        } else {
          personSign = personSign + `<span>${SignObject[users_name]}</span>`
        }
      }
    }
    personSign = personSign + '</div></div>'
  }

  const htmlStr = `
          <div class="printContainer">
            <div class="titleContainer">
              <h1>差 旅 费 报 销 单</h1>
            </div>

            <div class="dateContainer">
              <div>报销日期: ${ykDateFormat('yyyy-MM-dd', row.r_date)}</div>
              <div>公司: ${row.company}</div>
            </div>

            <table class="mainTable">
              <tr>
                <td colspan="5" rowspan="2" align="left">出差事由:&nbsp;${row.subject_matter}</td>
                <td colspan="2" rowspan="2">出差天数</td>
                <td colspan="4">${ykDateFormat('yyyy-MM-dd', row.e_begin_date)} 至 ${ykDateFormat(
    'yyyy-MM-dd',
    row.e_end_date
  )}</td>
              </tr>
              <tr>
                <td colspan="4">共 ${row.e_day_count} 天</td>
              </tr>
              <tr>
                <td rowspan="2" style="width: 60px !important;">日期</td>
                <td rowspan="2" style="width: 120px !important;">起讫地点</td>
                <td colspan="3">交通费</td>
                <td colspan="2">住宿费</td>
                <td rowspan="2" style="width: 80px !important">误餐补助</td>
                <td rowspan="2" style="width: 80px !important">公杂费</td>
                <td rowspan="2" style="width: 80px !important;">合计</td>
                <td rowspan="2" style="width: 50px;">备注</td>
              </tr>
              <tr>
                <td style="width: 80px;">类别</td>
                <td style="width: 30px;">票据张数</td>
                <td style="width: 70px;">含税金额</td>
                <td style="width: 30px;">票据张数</td>
                <td style="width: 70px;">含税金额</td>
              </tr>

              ${DetailHtmlList.join('')}

              <tr>
                <td colspan="2">合 计</td>
                <td> </td>
                <td>${traffic_sum_count}</td>
                <td>${traffic_sum_amount}</td>
                <td>${stay_sum_count}</td>
                <td>${stay_sum_amount}</td>
                <td>${meal_sum_amount}</td>
                <td>${miscellaneous_sum_amount}</td>
                <td>${XEUtils.sum([
                  traffic_sum_amount,
                  stay_sum_amount,
                  meal_sum_amount,
                  miscellaneous_sum_amount
                ])}</td>
                <td> </td>
              </tr>

              <tr>
                <td colspan="4">
                  <div style="width: 100%;height: 100%;text-align: left;">
                    <span>各项支出合计:</span>
                    <br />
                    <span style="font-size: 16px;">(￥${XEUtils.commafy(row.total_expenses, { digits: 2 })})</span>
                    &nbsp;<span style="font-size: 16px;">${AmountLtoU(row.total_expenses)}</span>
                  </div>
                </td>
                <td colspan="7" style="padding: 0;">
                  <table class="detailTable" style="margin: 0;z-index: 9999;background-color: #fff;">

                    <tr>
                      <td rowspan="4" style="border: 0;width: 30px;">票据张数</td>
                      <td style="width: 37px;">${row.office_count}</td>
                      <td>办公费 ${row.office_expenses} 元</td>
                      <td rowspan="4" style="border: 0;width: 30px;">票据张数</td>
                      <td style="width: 37px;">${row.post_count}</td>
                      <td style="border-right: 0;">邮电费 ${row.post_expenses} 元</td>
                    </tr>

                    <tr>
                      <td>${row.meal_count}</td>
                      <td>&emsp;餐费 ${row.meal_expenses} 元</td>
                      <td>${row.check_count}</td>
                      <td style="border-right: 0;">检定费 ${row.check_expenses} 元</td>
                    </tr>

                    <tr>
                      <td>${row.traffic_count}</td>
                      <td>交通费 ${row.traffic_expenses} 元</td>
                      <td>${row.other_count}</td>
                      <td style="border-right: 0;">其他费 ${row.other_expenses} 元</td>
                    </tr>

                  </table>
                </td>
              </tr>
            </table>

            <div class="footerContainer">
              <div class="signContainer">领导审批:
              <div class="signItems">${yaozongSign}</div>
            </div>
              <div class="signContainer">单位主管:
                <div class="signItems">${lingongSign}</div>
              </div>
              <div class="signContainer">财务审核:
                <div class="signItems">${caiwuSign}</div>
              </div>
              ${personSign}
            </div>
          </div>
      `

  const htmlCss = `
          html,
          body {
            width: 100vw;
            height: 100vh;
            margin: 0 !important;
            padding: 0 !important;

            font-size: 14px;
          }

          .printContainer {
            box-sizing: border-box;
            padding: 10px;
          }

          .dateContainer {
            display: flex;
            justify-content: space-between;
          }

          .titleContainer {
            text-align: center;
          }

          .titleContainer h1 {
            font-size: 30px;
            font-weight: 400;
          }

          .footerContainer {
            display: flex;
            justify-content: space-between;
          }

          .footerContainer div {
            width: 30%;
          }

          table {
            text-align: center;
            border-collapse: collapse;
            width: 100%;
          }

          table td {
            box-sizing: border-box;
            padding: 3px;
            border: 1px solid #000000;

            height: 26px;

            font-size: 14px;
          }

          .detailTable {
            /* width: calc(100% + 4px); */
            /* margin-left: -2px !important; */
            /* margin-top: -2px !important; */
          }

          .detailTable tr:first-child td {
            border-top: 0;
          }

          .detailTable tr:last-child td {
            border-bottom: 0;
          }

          .mainTable {
            margin: 5px 0 15px 0;
          }

          .signContainer, .signsContainer {
            position: relative;
          }

          .signItems {
            position: absolute;
            left: 70px;
            top: -10px;
          }

          .signItems img {
            width: 80px;
          }

          .signsContainer .signItems {
            width: 100px;
            display: flex;
            flex-wrap: wrap;
          }

          .signsContainer .signItems img {
            width: 50px;
            flex: 0 0;
            align-self: center;
          }
      `

  VXETable.print({
    style: htmlCss,
    // 自定义打印HTML
    content: htmlStr
  })
}
